<script setup lang="ts">
import ProfileTab from '@/components/account/ProfileTab.vue';

definePage({
  name: 'account-profile',
});
</script>

<template>
  <div class="account-container p-6">
    <h2 class="text-2xl font-bold mb-6 text-gray-900">
      Profile Settings
    </h2>

    <ProfileTab />
  </div>
</template>

<style scoped>
.account-container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
